import config from "@/config";
import { useLogto } from "@logto/react";
import { createFileRoute } from "@tanstack/react-router";

import useVerifyInvitation from "@/hooks/api/invitation/useVerifyInvitation";

const Join = () => {
  const { token, email, invitationId } = Route.useSearch();
  const { signIn } = useLogto();
  const { data: verifiedInvitation, isLoading: inviteIsValidating } = useVerifyInvitation(invitationId);

  if (!token || !email || !invitationId) return <p>This invitation link is invalid.</p>;

  if (inviteIsValidating || !verifiedInvitation) return <p>Validating your invitation...</p>;

  if (verifiedInvitation.status === "EXPIRED") return <p>This invitation link has expired.</p>;

  if (verifiedInvitation.status === "NOT_FOUND") return <p>This invitation link is invalid.</p>;

  if (verifiedInvitation.status === "VALID") {
    signIn({
      redirectUri: config.FRONTEND_URL + config.LOGTO_CALLBACK,
      extraParams: {
        one_time_token: token,
        login_hint: email,
      },
    });
  }

  return (
    <p>
      An unknown error occurred please contact our support at <a href="mailto:support@octrace.ai">support@octrace.ai</a>
      .
    </p>
  );
};

export const Route = createFileRoute("/join")({
  component: Join,
  validateSearch: (search: Record<string, unknown>) => {
    return {
      token: (search.token as string) || undefined,
      email: (search.email as string) || undefined,
      invitationId: (search.invitationId as string) || undefined,
    };
  },
});
